import {
  GET_COURSES,
  GET_COURSE_ITEM,
  UPDATE_COURSE_ITEM,
  SET_COURSE_ITEM,
  ERROR_COURSE,
  SET_LOADING_COURSE,
  SET_LOADING_ALL_COURSE_RUN_DEMANDS,
  GET_ALL_COURSE_RUN_DEMANDS,
  GET_COURSE_RUN_DEMAND,
  ERROR_COURSE_RUN_DEMANDS,
  SET_COURSE_RUN_DEMAND_ACCEPTED,
  SET_COURSE_RUN_DEMAND_REJECTED,
  SEARCH_COURSES,
  SET_PRE_REQUISITE_LOADING,
  SET_LOADING_COURSE_IMAGE_FILE,
  SET_LOADING_COURSE_VIDEO_FILE,
  UPDATE_COURSE_IMAGE_FILE,
  UPDATE_COURSE_VIDEO_FILE,
  ERROR_COURSE_FILE_DATA,
  GET_ALL_MY_COURSE_RUN_DEMANDS,
  ERROR_MY_COURSE_RUN_DEMANDS,
} from '../types';
import axiosInstance from '../request';
import { toast } from 'react-toastify';
import Toast from '../../../components/Toast';
import { txtRT } from '../../../utils/texts';

export const getCourses = () => async dispatch => {
  try {
    dispatch({ type: SET_LOADING_COURSE });

    const res = await axiosInstance.get(`/course-runs/`);
    dispatch({
      type: GET_COURSES,
      payload: res.data.results,
    });
  } catch (e) {
    dispatch({
      type: ERROR_COURSE,
      payload: e.response.data,
    });
  }
};

export const searchCourses = tags => async dispatch => {
  try {
    dispatch({ type: SET_PRE_REQUISITE_LOADING });

    const res = await axiosInstance.get(`/search/course_runs/?tags__contains=${tags}/`);
    dispatch({
      type: SEARCH_COURSES,
      payload: res.data.results,
    });
  } catch (e) {
    dispatch({
      type: ERROR_COURSE,
      payload: e.response.data,
    });
  }
};

export const getCourseItem = (id, role) => async dispatch => {
  try {
    dispatch({ type: SET_LOADING_COURSE });

    const res = await axiosInstance.get(`/manage/${role}/course-run-demands/${id}/`);
    const dataRes = res.data;

    dispatch({
      type: GET_COURSE_ITEM,
      payload: dataRes,
    });
  } catch (e) {
    console.log(e);
    dispatch({
      type: ERROR_COURSE,
      payload: e.response.data,
    });
  }
};

/*
 * @description: create course run demands from instructor
 * @param: data{run, number, organization_id}
 * */
export const setCourseItem = (data, role) => async dispatch => {
  return axiosInstance
    .post(`/manage/${role}/course-run-demands/`, data)
    .then(function(res) {
      dispatch({ type: SET_LOADING_COURSE });

      dispatch({
        type: SET_COURSE_ITEM,
        payload: res.data,
      });
      return res.data;
    })
    .catch(function(e) {
      dispatch({
        type: ERROR_COURSE,
        payload: e.response.data,
      });
      return e;
    });
};

export const setCourseItemNull = () => dispatch => {
  dispatch({ type: SET_COURSE_ITEM, payload: null });
};

/**
 *
 * @param {number} id
 * @param {string} role
 * @param {object} data
 *
 */
export const updateCourseItem = (id, role, data) => async dispatch => {
  try {
    dispatch({ type: SET_LOADING_COURSE });

    let res = await axiosInstance.put(`/manage/${role}/course-run-demands/${id}/`, data);

    let isPublish = data.publish;

    let dataRes = res.data;
    if (Boolean(isPublish)) dataRes = { ...dataRes, publish: true };
    else dataRes = { ...dataRes, publish: false };

    dispatch({ type: UPDATE_COURSE_ITEM, payload: dataRes });
  } catch (e) {
    dispatch({
      type: ERROR_COURSE,
      payload: e.response.data,
    });
  }
};

/**
 *
 * @param {number} id
 * @param {string} role
 * @param {object} data
 * @param {string} type
 *
 */
export const updateCourseFileData = (id, role, data, type) => async dispatch => {
  try {
    if (type === 'image') dispatch({ type: SET_LOADING_COURSE_IMAGE_FILE });
    else dispatch({ type: SET_LOADING_COURSE_VIDEO_FILE });

    await axiosInstance.put(`/manage/${role}/course-run-demands/${id}/`, data);

    if (type === 'image') dispatch({ type: UPDATE_COURSE_IMAGE_FILE });
    else dispatch({ type: UPDATE_COURSE_VIDEO_FILE });
  } catch (error) {
    dispatch({ type: ERROR_COURSE_FILE_DATA, payload: error.response.data });
  }
};

/**
 *
 * @param {string} role
 *
 */

export const getAllCourseRunDemands = (role, pageSize, { page = 1, search = '', ordering = '' }) => async dispatch => {
  let params = {
    page_size: pageSize,
    page: page,
    ...(search && { search: search }),
    ...(ordering && { ordering: ordering }),
  };
  try {
    dispatch({ type: SET_LOADING_ALL_COURSE_RUN_DEMANDS });
    const res = await axiosInstance.get(`/manage/${role}/incoming-course-run-demands/`, { params });

    dispatch({
      type: GET_ALL_COURSE_RUN_DEMANDS,
      payload: res.data,
    });
  } catch (e) {
    dispatch({
      type: ERROR_COURSE_RUN_DEMANDS,
      payload: e?.response?.data,
    });
  }
};

/**
 *
 * @param {string} role
 * @param {string} id
 * @param {string} status
 * @param {function} callback
 * @param {string} errorReason
 *
 */
export const setCourseRunDemandsStatus = (role, id, status, callback, errorReason) => async dispatch => {
  if (role === 'course_creator') {
    role = 'course-creator';
  }

  try {
    dispatch({ type: SET_LOADING_ALL_COURSE_RUN_DEMANDS });
    await axiosInstance.patch(`/manage/${role}/incoming-course-run-demands/${id}/${status}/`, {
      message: errorReason,
    });

    if (status == 'accept') {
      Toast('دوره با موفقیت تایید شد', 'success');
      dispatch({
        type: SET_COURSE_RUN_DEMAND_ACCEPTED,
      });
      callback();
    } else {
      Toast('دوره با موفقیت رد شد', 'success');
      dispatch({
        type: SET_COURSE_RUN_DEMAND_REJECTED,
      });
      callback();
    }
  } catch (e) {
    dispatch({
      type: ERROR_COURSE_RUN_DEMANDS,
      payload: e?.response?.data,
    });
  }
};

/**
 *
 * @param {string} id
 * @param {string} role
 *
 */

export const getCourseRunDemand = (id, role) => async dispatch => {
  try {
    const res = await axiosInstance.get(`/manage/${role}/incoming-course-run-demands/${id}/`);

    dispatch({
      type: GET_COURSE_RUN_DEMAND,
      payload: res.data,
    });
  } catch (e) {
    dispatch({
      type: ERROR_COURSE_RUN_DEMANDS,
      payload: e?.response?.data,
    });
  }
};

/**
 *
 * @param {string} role
 * @param {string} pageSize
 * @param {object} params
 *
 */

export const getAllMyCourseRunDemands = (
  role,
  pageSize,
  { page = 1, search = '', ordering = '' }
) => async dispatch => {
  let params = {
    page_size: pageSize,
    page: page,
    ...(search && { search: search }),
    ...(ordering && { ordering: ordering }),
  };

  try {
    dispatch({ type: SET_LOADING_ALL_COURSE_RUN_DEMANDS });
    const res = await axiosInstance.get(`/manage/${role}/course-run-demands/`, { params });
    dispatch({
      type: GET_ALL_MY_COURSE_RUN_DEMANDS,
      payload: res.data,
    });
  } catch (e) {
    dispatch({
      type: ERROR_MY_COURSE_RUN_DEMANDS,
      payload: e?.response?.data,
    });
  }
};
